// @flow

// Effect Managers
import { fork } from 'redux-saga/effects'

// Sagas
import watchPreselectedJob from './watchPreselectedJob'
import watchSelectedJob from './watchSelectedJob'
import watchLoadSoilPropsMapData from './watchLoadSoilPropsMapData'
import watchChangesToSpatial from 'fc-spatial/src/sagas/watchChangesToSpatial'


export default function *main (): Generator<*, *, *> {
  yield fork(watchPreselectedJob)
  yield fork(watchSelectedJob)
  yield fork(watchLoadSoilPropsMapData)
  yield fork(watchChangesToSpatial)
}
